import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { PumpService } from 'src/app/services/pump.service';


@Component({
  selector: 'app-pumpaddedit',
  templateUrl: './pumpaddedit.component.html',
  styleUrls: ['./pumpaddedit.component.scss']
})
export class PumpaddeditComponent implements OnInit {
  descriptionForm: FormGroup
  parameters: FormGroup
  alertParameter: FormGroup
  altertNotification: FormGroup
  dtmuDevice: FormGroup
  formData:any= {};
  uploadedFiles: Array < File > ;
  //selected = '1234';
  DeviceCategory = ['Power', 'Solar', 'Distribution'];
  DeviceId = ['K001H20','K001H22','K001H22','KR-1139','BH-1131'];
  DeviceModel = ['A10', 'A20', 'A30'];
  Frequency = ['Minutes','Days','Hours'];
  frequencyError: any;
  frequencyMsg: any = {};
  deviceMaster: any;
  pumpid: string[] = ['pump-032']; // Dummy array with one serial number

  action: string;
  userId = JSON.parse(localStorage.getItem('userData')).roleid;
  constructor( public dialogRef: MatDialogRef<PumpaddeditComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
               private formBuilder: FormBuilder, private http: HttpClient,private toastr: ToastrService, private transformerMangService: TransformerManagerService,private PumpService:PumpService, private ngxLoader: NgxUiLoaderService){ }

  async ngOnInit() {
    this.PumpService.getPumpids().toPromise().then((response: any) => {
      console.log("response of pump ids", response);
      this.pumpid = response.data.map(item => item.pump_id);
      console.log("this.pumpid", this.pumpid);
  });
  
    
    if(this.data.transformerData === 'Add') {

           this.action = "Add";
           this.deviceMaster = this.data.dropDownData;
          this.createForm();


   } else {
     this.action = 'Update';
    this.deviceMaster = this.data.dropDownData;
    this.createForm();
   }


  }

   duplicateSerialValidator(pumpid: string[]): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
        const value = control.value;
       
        if (this.pumpid.includes(value)) {
            return { 'duplicateSerial': true };
        }
        return null;
    };
}
  async createForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.descriptionForm = this.formBuilder.group({
      'transformerMakeBy': [null, [Validators.required]],
      'pumpMakeBy': [null, [Validators.required]],
      'serialnumber': [null, [Validators.required, this.duplicateSerialValidator(this.pumpid)]],
      'manufacturingDate': [null, [Validators.required, Validators.minLength(5), Validators.maxLength(10)]],
      'installationDate': [null, [Validators.required, Validators.minLength(5), Validators.maxLength(10)]],
    
    });

    this.parameters = this.formBuilder.group({
      'pumpcurrent': [true],
      'motordetemp': [true],
      'motorndetemp': [true],
      'motorrphasetemp': [true],
      'motoryphasetemp': [true],
      'motorbphasetemp':[true],
      'sumplevel':[true],
      'waterlevel':[true],
      'pumponfeedback': [true],
      'pumpdischargelow': [true],
      'motoroverload': [true],
      'lightingonfeedback': [true],
      'abswitchonfeedback': [true]

    })

    this.alertParameter = this.formBuilder.group({
      'pumpcurrent':[0],
      'pumpcurrentemail':false,
      'pumpcurrentsms':false,
      'pumpcurrentfrequency':[1],
      'pumpcurrenttime':'Minutes',

      'motordetemperature':[0],
      'motordetemperatureemail':false,
      'motordetemperaturesms':false,
      'motordetemperaturefrequency':[1],
      'motordetemperaturetime':'Minutes',
     
      'motorndetemperature':[0],
      'motorndetemperatureemail':false,
      'motorndetemperaturesms':false,
      'motorndetemperaturefrequency':[1],
      'motorndetemperaturetime':'Minutes',

      'motorrphasetemperature':[0],
      'motorrphasetemperatureemail':false,
      'motorrphasetemperaturesms':false,
      'motorrphasetemperaturefrequency':[1],
      'motorrphasetemperaturetime':'Minutes',

      'motoryphasetemperature':[0],
      'motoryphasetemperatureemail':false,
      'motoryphasetemperaturesms':false,
      'motoryphasetemperaturefrequency':[1],
      'motoryphasetemperaturetime':'Minutes',

      'motorbphasetemperature':[0],
      'motorbphasetemperatureemail':false,
      'motorbphasetemperaturesms':false,
      'motorbphasetemperaturefrequency':[1],
      'motorbphasetemperaturetime':'Minutes',

      'sumpllevel':[0],
      'sumpllevelemail':false,
      'sumpllevelsms':false,
      'sumpllevelfrequency':[1],
      'sumplleveltime':'Minutes',

      'pumponffeedback':[0],
      'pumponffeedbackemail':false,
      'pumponffeedbacksms':false,
      'pumponffeedbackfrequency':[1],
      'pumponffeedbacktime':'Minutes',

      'pumpdplow':[0],
      'pumpdplowemail':false,
      'pumpdplowsms':false,
      'pumpdplowfrequency':[1],
      'pumpdplowtime':'Minutes',

      'overload':[0],
      'overloademail':false,
      'overloadsms':false,
      'overloadfrequency':[1],
      'overloadtime':'Minutes',

      'lighttonfeedback':[0],
      'lighttonfeedbackemail':false,
      'lighttonfeedbacksms':false,
      'lighttonfeedbackfrequency':[1],
      'lighttonfeedbacktime':'Minutes',

      'abswitchonfeedback':[0],
      'abswitchonfeedbackemail':false,
      'abswitchonfeedbacksms':false,
      'abswitchonfeedbackfrequency':[1],
      'abswitchonfeedbacktime':'Minutes',
    })

    this.altertNotification = this.formBuilder.group({
      'email1':[null, [Validators.required, Validators.email]],
      'email2': [null, [Validators.email]],
      'email3': [null, [Validators.email]],
      'email4': [null, [Validators.email]],
      'email5': [null, [Validators.email]],
      'phoneNo1': [null, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo2': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo3': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo4': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo5': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]]
    })
 
    var deviceId = this.deviceMaster.deviceId
    this.dtmuDevice = this.formBuilder.group({
      'deviceCategory':[this.deviceMaster.deviceCategory, [Validators.required]],
      'deviceModel':[this.deviceMaster.deviceModel, [Validators.required]],
      'transformerid': [this.deviceMaster.deviceId, [Validators.required]],
      'heartBeat': ['', [Validators.required]],
      'name': ['', [Validators.required]],
      'passcode': ['', [Validators.required]],
      'remoteController': false,
      'onoffNotify':false
           
    })

    if(this.data &&this.data.transformerData && this.data.transformerData !== 'Add' && Object.keys(this.data.transformerData).length > 0) {
      console.log('Description form values:',this.data.transformerData['description'][0]);
      //this.descriptionForm.patchValue(this.data.transformerData['description'][0]);

      this.descriptionForm.controls['transformerMakeBy'].setValue(this.data.transformerData['description'][0].transformer_make);
      this.descriptionForm.controls['pumpMakeBy'].setValue(this.data.transformerData['description'][0].pump_make_by);
      this.descriptionForm.controls['serialnumber'].setValue(this.data.transformerData['description'][0].pump_id);
      this.descriptionForm.controls['manufacturingDate'].setValue(this.data.transformerData['description'][0].manufacturing_date);
      this.descriptionForm.controls['installationDate'].setValue(this.data.transformerData['description'][0].installation_date);
   
      this.dtmuDevice.controls['deviceCategory'].setValue(this.data.transformerData['description'][0].devicecategory);
      this.dtmuDevice.controls['deviceModel'].setValue(this.data.transformerData['description'][0].devicemodel);
      this.dtmuDevice.controls['transformerid'].setValue(this.data.transformerData['description'][0].transformerid);
      this.dtmuDevice.controls['heartBeat'].setValue(this.data.transformerData['description'][0].heartbeat);
      this.dtmuDevice.controls['name'].setValue(this.data.transformerData['description'][0].name);
      this.dtmuDevice.controls['passcode'].setValue(this.data.transformerData['description'][0].passcode);
      this.dtmuDevice.controls['remoteController'].setValue(this.data.transformerData['description'][0].remoteController);
      this.dtmuDevice.controls['onoffNotify'].setValue(this.data.transformerData['description'][0].onoffNotify);
     
      this.parameters.controls['pumpcurrent'].setValue(this.data.transformerData['parameterConfig'][0].pumpcurrent==='1'? true: false)
      this.parameters.controls['motordetemp'].setValue(this.data.transformerData['parameterConfig'][0].motordetemp==='1'? true: false)
      this.parameters.controls['motorndetemp'].setValue(this.data.transformerData['parameterConfig'][0].motorndetemp==='1'? true: false)
      this.parameters.controls['motorrphasetemp'].setValue(this.data.transformerData['parameterConfig'][0].motorrphasetemp==='1'? true: false)
      this.parameters.controls['motoryphasetemp'].setValue(this.data.transformerData['parameterConfig'][0].motoryphasetemp==='1'? true: false)
      this.parameters.controls['motorbphasetemp'].setValue(this.data.transformerData['parameterConfig'][0].motorbphasetemp==='1'? true: false)
      this.parameters.controls['sumplevel'].setValue(this.data.transformerData['parameterConfig'][0].sumplevel==='1'? true: false)
      this.parameters.controls['waterlevel'].setValue(this.data.transformerData['parameterConfig'][0].waterlevel==='1'? true: false)
      this.parameters.controls['pumponfeedback'].setValue(this.data.transformerData['parameterConfig'][0].pumponfeedback==='1'? true: false)
      this.parameters.controls['pumpdischargelow'].setValue(this.data.transformerData['parameterConfig'][0].pumpdischargelow==='1'? true: false)
      this.parameters.controls['motoroverload'].setValue(this.data.transformerData['parameterConfig'][0].motoroverload==='1'? true: false)
      this.parameters.controls['lightingonfeedback'].setValue(this.data.transformerData['parameterConfig'][0].lightingonfeedback==='1'? true: false)
      this.parameters.controls['abswitchonfeedback'].setValue(this.data.transformerData['parameterConfig'][0].abswitchonfeedback==='1'? true: false)
     
    this.alertParameter.setValue({
      pumpcurrent:this.data.transformerData['alertParameters'][0].ParameterValue,
      pumpcurrentemail:this.data.transformerData['alertParameters'][0].Email==='1'? true: false,
      pumpcurrentsms:this.data.transformerData['alertParameters'][0].Sms==='1'? true: false,
      pumpcurrentfrequency:this.data.transformerData['alertParameters'][0].Frequency,
      pumpcurrenttime:this.data.transformerData['alertParameters'][0].Timevalue,
     
      motordetemperature:this.data.transformerData['alertParameters'][1].ParameterValue,
      motordetemperatureemail:this.data.transformerData['alertParameters'][1].Email==='1'? true: false,
      motordetemperaturesms:this.data.transformerData['alertParameters'][1].Sms==='1'? true: false,
      motordetemperaturefrequency:this.data.transformerData['alertParameters'][1].Frequency,
      motordetemperaturetime:this.data.transformerData['alertParameters'][1].Timevalue,
     
      motorndetemperature:this.data.transformerData['alertParameters'][2].ParameterValue,
      motorndetemperatureemail:this.data.transformerData['alertParameters'][2].Email==='1'? true: false,
      motorndetemperaturesms:this.data.transformerData['alertParameters'][2].Sms==='1'? true: false,
      motorndetemperaturefrequency:this.data.transformerData['alertParameters'][2].Frequency,
      motorndetemperaturetime:this.data.transformerData['alertParameters'][2].Timevalue,
     
      motorrphasetemperature:this.data.transformerData['alertParameters'][3].ParameterValue,
      motorrphasetemperatureemail:this.data.transformerData['alertParameters'][3].Email==='1'? true: false,
      motorrphasetemperaturesms:this.data.transformerData['alertParameters'][3].Sms==='1'? true: false,
      motorrphasetemperaturefrequency:this.data.transformerData['alertParameters'][3].Frequency,
      motorrphasetemperaturetime:this.data.transformerData['alertParameters'][3].Timevalue,
     
      motoryphasetemperature:this.data.transformerData['alertParameters'][4].ParameterValue,
      motoryphasetemperatureemail:this.data.transformerData['alertParameters'][4].Email==='1'? true: false,
      motoryphasetemperaturesms:this.data.transformerData['alertParameters'][4].Sms==='1'? true: false,
      motoryphasetemperaturefrequency:this.data.transformerData['alertParameters'][4].Frequency,
      motoryphasetemperaturetime:this.data.transformerData['alertParameters'][4].Timevalue,
     
      motorbphasetemperature:this.data.transformerData['alertParameters'][5].ParameterValue,
      motorbphasetemperatureemail:this.data.transformerData['alertParameters'][5].Email==='1'? true: false,
      motorbphasetemperaturesms:this.data.transformerData['alertParameters'][5].Sms==='1'? true: false,
      motorbphasetemperaturefrequency:this.data.transformerData['alertParameters'][5].Frequency,
      motorbphasetemperaturetime:this.data.transformerData['alertParameters'][5].Timevalue,
     
      sumpllevel:this.data.transformerData['alertParameters'][6].ParameterValue,
      sumpllevelemail:this.data.transformerData['alertParameters'][6].Email==='1'? true: false,
      sumpllevelsms:this.data.transformerData['alertParameters'][6].Sms==='1'? true: false,
      sumpllevelfrequency:this.data.transformerData['alertParameters'][6].Frequency,
      sumplleveltime:this.data.transformerData['alertParameters'][6].Timevalue,
     
      pumponffeedback:this.data.transformerData['alertParameters'][7].ParameterValue,
      pumponffeedbackemail:this.data.transformerData['alertParameters'][7].Email==='1'? true: false,
      pumponffeedbacksms:this.data.transformerData['alertParameters'][7].Sms==='1'? true: false,
      pumponffeedbackfrequency:this.data.transformerData['alertParameters'][7].Frequency,
      pumponffeedbacktime:this.data.transformerData['alertParameters'][7].Timevalue,
     
      pumpdplow:this.data.transformerData['alertParameters'][8].ParameterValue,
      pumpdplowemail:this.data.transformerData['alertParameters'][8].Email==='1'? true: false,
      pumpdplowsms:this.data.transformerData['alertParameters'][8].Sms==='1'? true: false,
      pumpdplowfrequency:this.data.transformerData['alertParameters'][8].Frequency,
      pumpdplowtime:this.data.transformerData['alertParameters'][8].Timevalue,
     
      overload:this.data.transformerData['alertParameters'][9].ParameterValue,
      overloademail:this.data.transformerData['alertParameters'][9].Email==='1'? true: false,
      overloadsms:this.data.transformerData['alertParameters'][9].Sms==='1'? true: false,
      overloadfrequency:this.data.transformerData['alertParameters'][9].Frequency,
      overloadtime:this.data.transformerData['alertParameters'][9].Timevalue,
     
      lighttonfeedback:this.data.transformerData['alertParameters'][10].ParameterValue,
      lighttonfeedbackemail:this.data.transformerData['alertParameters'][10].Email==='1'? true: false,
      lighttonfeedbacksms:this.data.transformerData['alertParameters'][10].Sms==='1'? true: false,
      lighttonfeedbackfrequency:this.data.transformerData['alertParameters'][10].Frequency,
      lighttonfeedbacktime:this.data.transformerData['alertParameters'][10].Timevalue,
     
      abswitchonfeedback:this.data.transformerData['alertParameters'][11].ParameterValue,
      abswitchonfeedbackemail:this.data.transformerData['alertParameters'][11].Email==='1'? true: false,
      abswitchonfeedbacksms:this.data.transformerData['alertParameters'][11].Sms==='1'? true: false,
      abswitchonfeedbackfrequency:this.data.transformerData['alertParameters'][11].Frequency,
      abswitchonfeedbacktime:this.data.transformerData['alertParameters'][11].Timevalue,
     });

    this.altertNotification.controls['email1'].setValue(this.data.transformerData['alertNotifications'][0].email1);
      this.altertNotification.controls['email2'].setValue(this.data.transformerData['alertNotifications'][0].email2);
      this.altertNotification.controls['email3'].setValue(this.data.transformerData['alertNotifications'][0].email3);
      this.altertNotification.controls['email4'].setValue(this.data.transformerData['alertNotifications'][0].email4);
      this.altertNotification.controls['email5'].setValue(this.data.transformerData['alertNotifications'][0].email5);
      this.altertNotification.controls['phoneNo1'].setValue(this.data.transformerData['alertNotifications'][0].phoneNo1);
      this.altertNotification.controls['phoneNo2'].setValue(this.data.transformerData['alertNotifications'][0].phoneNo2);
      this.altertNotification.controls['phoneNo3'].setValue(this.data.transformerData['alertNotifications'][0].phoneNo3);
      this.altertNotification.controls['phoneNo4'].setValue(this.data.transformerData['alertNotifications'][0].phoneNo4);
      this.altertNotification.controls['phoneNo5'].setValue(this.data.transformerData['alertNotifications'][0].phoneNo5);
     
    }


  }


  getDeviceDdl()
 {
  this.transformerMangService.getDeviceDdl().toPromise().then((response:any) => {

    //this.deviceMaster = response;
   // console.log('RESPONSE:', this.deviceMaster);
   console.log('Responses fetched:', response)
    return response;
   //console.log('VALUES :', Object.keys(response.message[0]).map(function (key) { return response.message[0][key]; }));
  })

 }

 close(response) {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(value => {
      console.log(`Dialog sent:`, response);
    });

  }

  public errorHandling = (control: string, error: string) => {
    console.log('Control:',this.descriptionForm.controls[control])
    console.log( this.descriptionForm.controls[control].hasError(error));
    return this.descriptionForm.controls[control].hasError(error)
  }

  onSubmit(descroptionValues, parametersValues, alertParametersValues, altertNotificationValues, dtmuDeviceValues) {
      this.ngxLoader.start();
       // if(this.descriptionForm.valid && this.parameters.valid && this.alertParameter.valid && this.altertNotification.valid && this.dtmuDevice.valid ){
      descroptionValues.deleteFlag = "A",
      descroptionValues.createdBy = JSON.parse(localStorage.getItem('userData')).userid;
      var today = new Date();
      var date='';
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      date = yyyy + '-' + mm + '-' + dd;

      descroptionValues.createdDate = Date.now().toString();
      var id= {'id': descroptionValues.serialnumber};
      var metaData = {'createdBy':JSON.parse(localStorage.getItem('userData')).userid, 'createdDate':date,'deleteFlag':'A'};
      this.formData.action = this.action;
      if(this.action === 'Update') {
       this.formData.serialnumber = descroptionValues.serialnumber;
         descroptionValues.manufacturingDate = typeof(descroptionValues.manufacturingDate) === 'object' ? moment(descroptionValues.manufacturingDate).format('YYYY-MM-DD') : descroptionValues.manufacturingDate.substr(0,10);
        descroptionValues.installationDate = typeof(descroptionValues.installationDate) === 'object' ? moment(descroptionValues.installationDate).format('YYYY-MM-DD') :  descroptionValues.installationDate.substr(0,10);
      }
      else {
       if(!this.descriptionForm.valid || !this.parameters.valid || !this.alertParameter.valid || !this.altertNotification.valid || !this.dtmuDevice.valid || (this.frequencyError && this.frequencyError.length > 0 )) {
          if(!this.frequencyError) {
            this.toastr.error('Please Enter Valid and Mandatory Values');
            return
          // return alert('Please Enter Valid and Mandatory Values');

          } else if(this.frequencyError && this.frequencyError.length > 0) {
            this.toastr.error(this.frequencyError);
            return;
          //  return alert(this.frequencyError);
          }

        }
      }

      dtmuDeviceValues.remoteController=dtmuDeviceValues.remoteController ? 1 :0;
      dtmuDeviceValues.onoffNotify=dtmuDeviceValues.onoffNotify ? 1 :0;
      this.formData.description = {...id, ...descroptionValues, ...dtmuDeviceValues, ...metaData};
      if(this.action === 'Update') {
        delete this.formData.description.id;
        delete this.formData.description.serialnumber;
      }
      this.formData.parameters = parametersValues;

    

      this.formData.alertParameter = [{"pumpcurrent":alertParametersValues.pumpcurrent, "email":alertParametersValues.pumpcurrentemail,"sms":alertParametersValues.pumpcurrentsms, "frequency":alertParametersValues.pumpcurrentfrequency, "timeValue":alertParametersValues.pumpcurrenttime},
      {"motordetemperature":alertParametersValues.motordetemperature, "email":alertParametersValues.motordetemperatureemail,"sms":alertParametersValues.motordetemperaturesms, "frequency":alertParametersValues.motordetemperaturefrequency, "timeValue":alertParametersValues.motordetemperaturetime},
      {"motorndetemperature":alertParametersValues.motorndetemperature, "email":alertParametersValues.motorndetemperatureemail,"sms":alertParametersValues.motorndetemperaturesms, "frequency":alertParametersValues.motorndetemperaturefrequency, "timeValue":alertParametersValues.motorndetemperaturetime},
      {"motorrphasetemperature":alertParametersValues.motorrphasetemperature, "email":alertParametersValues.motorrphasetemperatureemail,"sms":alertParametersValues.motorrphasetemperaturesms, "frequency":alertParametersValues.motorrphasetemperaturefrequency, "timeValue":alertParametersValues.motorrphasetemperaturetime},
      {"motoryphasetemperature":alertParametersValues.motoryphasetemperature, "email":alertParametersValues.motoryphasetemperatureemail,"sms":alertParametersValues.motoryphasetemperaturesms, "frequency":alertParametersValues.motoryphasetemperaturefrequency, "timeValue":alertParametersValues.motoryphasetemperaturetime},
      {"motorbphasetemperature":alertParametersValues.motorbphasetemperature, "email":alertParametersValues.motorbphasetemperatureemail,"sms":alertParametersValues.motorbphasetemperaturesms, "frequency":alertParametersValues.motorbphasetemperaturefrequency, "timeValue":alertParametersValues.motorbphasetemperaturetime},
      {"sumpllevel":alertParametersValues.sumpllevel, "email":alertParametersValues.sumpllevelemail,"sms":alertParametersValues.sumpllevelsms, "frequency":alertParametersValues.sumpllevelfrequency, "timeValue":alertParametersValues.sumplleveltime},
      {"pumponffeedback":alertParametersValues.pumponffeedback, "email":alertParametersValues.pumponffeedbackemail,"sms":alertParametersValues.pumponffeedbacksms, "frequency":alertParametersValues.pumponffeedbackfrequency, "timeValue":alertParametersValues.pumponffeedbacktime},
      {"pumpdplow":alertParametersValues.pumpdplow, "email":alertParametersValues.pumpdplowemail,"sms":alertParametersValues.pumpdplowsms, "frequency":alertParametersValues.pumpdplowfrequency, "timeValue":alertParametersValues.pumpdplowtime},
      {"overload":alertParametersValues.overload, "email":alertParametersValues.overloademail,"sms":alertParametersValues.overloadsms, "frequency":alertParametersValues.overloadfrequency, "timeValue":alertParametersValues.overloadtime},
      {"lighttonfeedback":alertParametersValues.lighttonfeedback, "email":alertParametersValues.lighttonfeedbackemail,"sms":alertParametersValues.lighttonfeedbacksms, "frequency":alertParametersValues.lighttonfeedbackfrequency, "timeValue":alertParametersValues.lighttonfeedbacktime},
      {"abswitchonfeedback":alertParametersValues.abswitchonfeedback, "email":alertParametersValues.abswitchonfeedbackemail,"sms":alertParametersValues.abswitchonfeedbacksms, "frequency":alertParametersValues.abswitchonfeedbackfrequency, "timeValue":alertParametersValues.abswitchonfeedbacktime},];
     


        this.formData.alertNotification = altertNotificationValues;
     
     
      console.log('FORM DATA:', this.formData);

      if(this.frequencyError && this.frequencyError.length > 0) {
       // return alert(this.frequencyError);
        this.toastr.error(this.frequencyError);
        return;
      }

       this.PumpService.savePumpData(this.formData).subscribe((response) => {
         this.ngxLoader.stop();
           console.log("RESPONSE:", response);
           console.log("Form:", response);
            this.close(response);
       })

  }

  checkFrequency(event:any, frequency, time) {
    console.log("CHECK FREQUENCY:", event.target.value, frequency, time);
    console.log(this.alertParameter);
    console.log(this.alertParameter.value[time]);
    if(this.alertParameter.value[time] === 'Minutes') {
      if(event.target.value >  1440  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-31';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    } else if(this.alertParameter.value[time] === 'Hours') {
      if(event.target.value >  11  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-11';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    } else if(this.alertParameter.value[time] === 'Minutes') {
      if(event.target.value >  59  || event.target.value < 1) {
       // this.alertParameter.controls.frequency.setValidators([Validators.minLength(1), Validators.maxLength(31)]);
        this.frequencyMsg[frequency] = 'Frequency value should be between 1-59';
        this.frequencyError = 'There are Errors in Alert Parameters Form'
      } else {
        this.frequencyMsg[frequency] = '';
        this.frequencyError = ''
      }
    }
  }

}
